import { Color } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { AppZIndex } from '../../enums';

export const Wrapper = styled.div`
  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }

  width: 100%;
  height: 100%;
  background-color: ${Color.White100};
  z-index: ${AppZIndex.LoadingScreen};
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
`;
